module.exports = __webpack_public_path__ + "static/media/ERM.4b8817e5.svg";